import React from "react";
import { useNavigate, useParams } from "react-router-dom";

const sections = [
  {
    key: "location",
    title: "All Locations",
    description: "Apply UI customizations across every subaccount.",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="3" width="7" height="7" rx="1.5" />
        <rect x="14" y="3" width="7" height="7" rx="1.5" />
        <rect x="3" y="14" width="7" height="7" rx="1.5" />
        <rect x="14" y="14" width="7" height="7" rx="1.5" />
      </svg>
    ),
  },
  {
    key: "location_groups",
    title: "Locations Group",
    description: "Customize the UI for a specific subaccount group.",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    key: "saas_customization",
    title: "SaaS Locations Group",
    description: "Customize the UI for SaaS subaccount groups.",
    icon: (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z" />
      </svg>
    ),
  },
];

export default function UIConfiguration() {
  const navigate = useNavigate();
  useParams();

  const handleNavigate = (level) => {
    navigate(`./${level}`);
  };

  return (
    <div
      className="min-vh-100 bg-white text-dark"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className="container py-5" style={{ maxWidth: 760 }}>
        <header className="mb-5">
          <h1 className="fw-semibold mb-2" style={{ fontSize: "1.625rem", letterSpacing: "-0.01em" }}>
            UI Configuration
          </h1>
          <p className="text-secondary mb-0" style={{ fontSize: "0.9375rem", lineHeight: 1.55 }}>
            Customize the user interface for different location groups within your organization.
          </p>
        </header>

        <div className="d-flex flex-column gap-2">
          {sections.map((section) => (
            <button
              key={section.key}
              type="button"
              onClick={() => handleNavigate(section.key)}
              className="ui-config-card d-flex align-items-center w-100 text-start bg-white"
            >
              <span className="ui-config-icon d-inline-flex align-items-center justify-content-center flex-shrink-0">
                {section.icon}
              </span>

              <span className="flex-grow-1 ms-3">
                <span className="d-block fw-semibold text-dark" style={{ fontSize: "0.9375rem" }}>
                  {section.title}
                </span>
                <span className="d-block text-secondary" style={{ fontSize: "0.8125rem", marginTop: 2 }}>
                  {section.description}
                </span>
              </span>

              <span className="ui-config-arrow text-secondary ms-3 flex-shrink-0" aria-hidden>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </span>
            </button>
          ))}
        </div>
      </div>

      <style>{`
        .ui-config-card {
          border: 1px solid #ececec;
          border-radius: 10px;
          padding: 18px 20px;
          transition: border-color 0.15s ease, box-shadow 0.15s ease, transform 0.15s ease;
          cursor: pointer;
        }
        .ui-config-card:hover {
          border-color: #d4d4d4;
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04), 0 4px 12px rgba(0, 0, 0, 0.04);
        }
        .ui-config-card:focus-visible {
          outline: none;
          border-color: #4f46e5;
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.12);
        }
        .ui-config-card:hover .ui-config-arrow {
          color: #1f2937 !important;
          transform: translateX(2px);
        }
        .ui-config-arrow {
          transition: transform 0.15s ease, color 0.15s ease;
        }
        .ui-config-icon {
          width: 38px;
          height: 38px;
          border-radius: 8px;
          background: #f6f6f6;
          color: #333;
        }
      `}</style>
    </div>
  );
}
